import Icon from 'utils/icon';

import styles from './dashboardItem.module.scss';
import chartSample1 from 'assets/images/chart-sample1.jpg';
import chartSample2 from 'assets/images/chart-sample2.jpg';

interface inputProps {
	mainValue: number;
	description: string;
	state: 'increase' | 'decrease';
	percentageValue: number;
	index: number;
}

function DashboardItemComponent({ mainValue, description, percentageValue, state, index }: inputProps) {
	return (
		<div className={styles.statistics_item}>
			<div>
				<h2>
					{mainValue}
					<span className={`status ${state === 'increase' ? 'active' : 'danger'}`}>
						<Icon name={`${state === 'increase' ? 'upArrow' : 'downArrow'}`} width={10} height={10} />
						{percentageValue}%
					</span>
				</h2>
				<p>{description}</p>
			</div>
			<img alt="chart" src={index % 2 == 0 ? chartSample1 : chartSample2}></img>
		</div>
	);
}

export default DashboardItemComponent;
